module.exports = __webpack_public_path__ + "static/img/b17.abeb079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b17.jpg
// module id = HSvQ
// module chunks = 1